import jstz from "jstz";

// Rails doesn't support every timezone that Intl supports
function findTimeZone() {
  const oldIntl = window.Intl;
  try {
    window.Intl = undefined;
    const tz = jstz.determine().name();
    window.Intl = oldIntl;
    return tz;
  } catch (e) {
    // sometimes (on android) you can't override intl
    return jstz.determine().name();
  }
}

document.addEventListener("turbo:load", () => {
  const timezone = findTimeZone();

  var expires = new Date();
  expires.setTime(expires.getTime() + 24 * 60 * 60 * 1000);
  document.cookie =
    "timezone" + "=" + timezone + ";expires=" + expires.toUTCString();
});
